module.exports = __webpack_public_path__ + "static/media/plus-dark.3b8d3c52.svg";